import Paper from '@mui/material/Paper';
import React from 'react';
import Grid from '../../fhg/components/Grid';
import FaqTable from './FaqTable';

/**
 * Super admin page for managing the general FAQ set (operatorId IS NULL) shown to every operator in the mobile app.
 * Operator-specific FAQ entries are managed from the FAQ tab on the Operator detail page.
 */
export default function Faq() {
   return (
      <Grid name={'FAQ Root Grid'} container direction={'column'} wrap={'nowrap'} style={{ position: 'relative' }}>
         <Grid name={'FAQ Content Grid'} item resizable fullHeight fullWidth style={{ width: '100%' }}>
            <Paper square style={{ margin: 16, padding: 16, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
               <FaqTable operatorId={null} />
            </Paper>
         </Grid>
      </Grid>
   );
}
